import { default as aboutcGvMViY0SnMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as serviceszlfYtypW62Meta } from "/opt/buildhome/repo/pages/services.vue?macro=true";
import { default as storyxNnvb654ixMeta } from "/opt/buildhome/repo/pages/story.vue?macro=true";
import { default as teamQ6SxuPfnNIMeta } from "/opt/buildhome/repo/pages/team.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/opt/buildhome/repo/pages/services.vue")
  },
  {
    name: "story",
    path: "/story",
    component: () => import("/opt/buildhome/repo/pages/story.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/opt/buildhome/repo/pages/team.vue")
  }
]